var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"backButton",attrs:{"color":_vm.color,"text":"","disabled":_vm.isDisabled},on:{"click":_vm.navigate}},[_vm._v(" "+_vm._s(_vm.$t(`components.login.LoginComponentNavigationButton.${_vm.to}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }